import { useMutation, useQueryClient } from "react-query";
import axios from "../axios";
import { AddBundlingResponse } from "../../constants/types";

type UpdateBundlingBody = {
    id: number | string;
    formData: FormData;
};

const updateBundling = async ({ id, formData }: UpdateBundlingBody) => {
    const response = await axios.post<AddBundlingResponse>(
        `api/item/bundlingupdate/${id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
    );
    return response.data;
};

export default function useUpdateBundling() {
    const queryClient = useQueryClient();

    return useMutation((body: UpdateBundlingBody) => updateBundling(body), {
        onSuccess: () => {
            queryClient.invalidateQueries(["item"]);
        },
    });
}
